import { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import { useLocation, useNavigate } from "react-router-dom";

export function useSearch() {
  const location = useLocation();
  const search = new URLSearchParams(location.search);

  const [searchString, setSearchString] = useState(search.get("search") || "");
  const [startDate, setStartDate] = useState(search.get("start") || null);
  const [endDate, setEndDate] = useState(search.get("end") || null);

  const [firstLoad, setFirstLoad] = useState(false)

  const nav = useNavigate();

  const changeQueryParam = (param, value) => {
    if(!firstLoad) return setFirstLoad(true)
    const newSearch = new URLSearchParams(location.search);
    if (value === null || value === "") {
      newSearch.delete(param);
    } else {
      newSearch.set(param, value);
    }
    nav(`/?${newSearch.toString()}`);
    window.location.reload();
    
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      changeQueryParam("search", searchString);
    }, 2000);

    return () => clearTimeout(timeout);
  }, [searchString]);

  const handleSearchStringChange = (value) => {
    setSearchString(value);
  };

  const handleStartDateChange = (date) => {
    const value = date ? Math.floor(date.getTime() / 1000) : null;
    setStartDate(value);
    changeQueryParam("start", value);
  };

  const handleEndDateChange = (date) => {
    const value = date ? Math.floor(date.getTime() / 1000) : null;
    setEndDate(value);
    changeQueryParam("end", value);
  };

  const context = (
    <div>
      <div className="mt-2 flex overflow-x-auto">
        
        <div className="flex flex-col gap-1">
          <DatePicker
            selected={startDate ? new Date(startDate * 1000) : null}
            onChange={handleStartDateChange}
            dateFormat="dd/MM/yyyy"
            className="block rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            placeholderText="Сделки с"
            onClick={() => setEndDate(null)}
          />
          <div className="text-rose-500 text-xs" onClick={() => {
            changeQueryParam("start", null);
            setStartDate(null)
          }}>Сбросить</div>
        </div>

        <div className="flex flex-col gap-1">
          <DatePicker
            selected={endDate ? new Date(endDate * 1000) : null}
            onChange={handleEndDateChange}
            dateFormat="dd/MM/yyyy"
            className="block ml-2 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            placeholderText="Сделки по"
          /> 
          <div className="text-rose-500 text-xs" onClick={() => {
            changeQueryParam("end", null);
            setEndDate(null)
          }}>Сбросить</div>
        </div>
        
        <input
          type="text"
          value={searchString}
          onChange={(e) => handleSearchStringChange(e.target.value)}
          className="block ml-2 h-9 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          placeholder="Номер сделки"
        />
      </div>
    </div>
  );

  return {
    search: context,
    changeQueryParam: changeQueryParam
  };
}
